/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventProxy } from "./EventProxy";
import { Point_$type, runOn, markType, PointUtil, String_$type, Delegate_$type } from "./type";
import { Rect } from "./Rect";
import { MouseEventArgs } from "./MouseEventArgs";
import { Dictionary$2 } from "./Dictionary$2";
import { List$1 } from "./List$1";
/**
 * @hidden
 */
var BaseDOMEventProxy = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(BaseDOMEventProxy, _super);
    function BaseDOMEventProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.by = null;
        _this.bp = false;
        _this.br = false;
        _this.bx = null;
        _this.bi = false;
        _this.bv = 0;
        _this.bw = 0;
        _this.bt = 0;
        _this.bu = 0;
        _this.bz = 0;
        _this.cx = null;
        _this.cw = null;
        _this.bh = false;
        _this.b0 = -1;
        _this.bm = false;
        _this.bj = false;
        _this.bg = false;
        return _this;
    }
    BaseDOMEventProxy.prototype.d = function () {
        var a = new DOMEventProxy(this.by, this.bx, this.br);
        a.aa = this.aa;
        a.al = this.al;
        return a;
    };
    Object.defineProperty(BaseDOMEventProxy, "bs", {
        get: function () {
            return (BaseDOMEventProxy.bn || BaseDOMEventProxy.bo);
        },
        enumerable: true,
        configurable: true
    });
    BaseDOMEventProxy.prototype.be = function (a) {
        return DOMEventProxy.cy(a);
    };
    BaseDOMEventProxy.prototype.bl = function (e_) {
        var pointerEvent_ = e_.originalEvent;
        var a = false;
        if (BaseDOMEventProxy.bo) {
            a = (pointerEvent_.pointerType == 'touch');
        }
        else {
            a = (pointerEvent_.pointerType == pointerEvent_.MSPOINTER_TYPE_TOUCH);
        }
        return a;
    };
    BaseDOMEventProxy.prototype.co = function (a) {
        if (!this.ac) {
            if (this.bk(a)) {
                if (this.an == null || this.an(a)) {
                    a.preventDefault();
                }
            }
        }
    };
    BaseDOMEventProxy.prototype.bk = function (e_) {
        return (e_.originalEvent.cancelable || e_.originalEvent.cancelable == undefined);
    };
    BaseDOMEventProxy.prototype.ck = function () {
        var source_ = this.by.getNativeElement();
        BaseDOMEventProxy.cn(source_);
    };
    BaseDOMEventProxy.cn = function (source_) {
        if (BaseDOMEventProxy.bo) {
            source_.style.touchAction = 'none';
        }
        else {
            source_.style.msTouchAction = 'none';
        }
        source_.style.msUserSelect = 'none';
        source_.style.webkitTouchCallout = 'none';
        source_.style.webkitUserSelect = 'none';
        source_.style.khtmlUserSelect = 'none';
        source_.style.mozUserSelect = 'none';
        source_.style.userSelect = 'none';
    };
    BaseDOMEventProxy.ch = function (source_) {
        if (BaseDOMEventProxy.bo) {
            source_.style.touchAction = 'auto';
        }
        else {
            source_.style.msTouchAction = 'auto';
        }
        source_.style.msUserSelect = 'auto';
        source_.style.webkitTouchCallout = 'none';
        source_.style.webkitUserSelect = 'auto';
        source_.style.khtmlUserSelect = 'auto';
        source_.style.mozUserSelect = 'auto';
        source_.style.userSelect = 'auto';
    };
    BaseDOMEventProxy.prototype.ci = function () {
        var source_ = this.by.getNativeElement();
        BaseDOMEventProxy.ch(source_);
    };
    BaseDOMEventProxy.prototype.ar = function () {
        _super.prototype.ar.call(this);
        if (!this.ac) {
            this.ck();
        }
        else {
            this.ci();
        }
    };
    BaseDOMEventProxy.prototype.b5 = function () {
        var ver_ = -1;
        var matchIE_ = /Trident\/([\d.]+)/;
        if ((matchIE_.exec(navigator.userAgent) != null)) {
            ver_ = (parseFloat(RegExp.$1));
        }
        return ver_;
    };
    BaseDOMEventProxy.prototype.b4 = function () {
        var ver_ = -1;
        var matchIE_ = /Edge\/([\d.]+)/;
        if ((matchIE_.exec(navigator.userAgent) != null)) {
            ver_ = (parseFloat(RegExp.$1));
        }
        return ver_;
    };
    BaseDOMEventProxy.cm = function (e_) {
        var a = BaseDOMEventProxy.b6 >= 6;
        var oe_ = e_.originalEvent;
        if ((((typeof e_.pageX == 'undefined')) || a) && oe_.clientX != null) {
            var od_ = void 0;
            if ((e_.target !== undefined)) {
                od_ = e_.target.ownerDocument;
            }
            else {
                od_ = e_.originalEvent.target.ownerDocument;
            }
            var ed_ = od_ ? od_ : document;
            var doc_ = ed_.documentElement;
            var body_ = ed_.body;
            var clientX_ = oe_.clientX;
            var clientY_ = oe_.clientY;
            var scrollLeft_ = doc_ && doc_.scrollLeft || body_ && body_.scrollLeft || 0;
            var scrollTop_ = doc_ && doc_.scrollTop || body_ && body_.scrollTop || 0;
            var clientLeft_ = doc_ && doc_.clientLeft || body_ && body_.clientLeft || 0;
            var clientTop_ = doc_ && doc_.clientTop || body_ && body_.clientTop || 0;
            e_.pageX = clientX_ + (scrollLeft_ - clientLeft_);
            e_.pageY = clientY_ + (scrollTop_ - clientTop_);
        }
        if ((!e_.pageX)) {
            e_.pageX = e_.originalEvent.pageX;
        }
        if ((!e_.pageY)) {
            e_.pageY = e_.originalEvent.pageY;
        }
        if (((typeof e_.button == 'undefined')) && ((typeof oe_.button != 'undefined'))) {
            e_.button = oe_.button;
        }
    };
    BaseDOMEventProxy.cy = function (a) {
        var b = BaseDOMEventProxy.b6 >= 6;
        var source_ = a.getNativeElement();
        var d_ = source_.ownerDocument;
        var doc_ = d_ ? d_.documentElement : null;
        var z_ = doc_ ? doc_.msContentZoomFactor : null;
        var body_ = doc_.body;
        if ((z_ && z_ > 1) || b) {
            var rect_ = source_.getBoundingClientRect();
            var x_ = (rect_.left);
            var y_ = (rect_.top);
            var scrollLeft_ = (doc_ && doc_.scrollLeft || body_ && body_.scrollLeft || 0);
            var scrollTop_ = (doc_ && doc_.scrollTop || body_ && body_.scrollTop || 0);
            var clientLeft_ = (doc_ && doc_.clientLeft || body_ && body_.clientLeft || 0);
            var clientTop_ = (doc_ && doc_.clientTop || body_ && body_.clientTop || 0);
            var c = x_ + scrollLeft_ - clientLeft_;
            var d = y_ + scrollTop_ - clientTop_;
            return new Rect(0, c, d, 0, 0);
        }
        else {
            var e = a.getOffset();
            return new Rect(0, e.left, e.top, 0, 0);
        }
    };
    Object.defineProperty(BaseDOMEventProxy.prototype, "b2", {
        get: function () {
            return this.bz;
        },
        set: function (a) {
            this.bz = a;
        },
        enumerable: true,
        configurable: true
    });
    BaseDOMEventProxy.prototype.cr = function (a) {
        this.ao = a;
        BaseDOMEventProxy.cm(a);
        var b = BaseDOMEventProxy.cy(this.by);
        var c = 0;
        var d = 0;
        if (Rect.l_op_Inequality(this.bf, null)) {
            c = this.bf.left;
            d = this.bf.top;
        }
        this.bv = a.pageX - b.left;
        this.bw = a.pageY - b.top;
        this.bt = this.bv - c;
        this.bu = this.bw - d;
        this.cx = { $type: Point_$type, x: this.bv, y: this.bw };
        this.cw = { $type: Point_$type, x: this.bt, y: this.bu };
    };
    BaseDOMEventProxy.prototype.cs = function (e_) {
        this.ao = e_;
        BaseDOMEventProxy.cm(e_);
        if (BaseDOMEventProxy.bs) {
            var a = e_.pageX;
            var b = e_.pageY;
            var c = BaseDOMEventProxy.cy(this.by);
            this.bv = a - c.left;
            this.bw = b - c.top;
        }
        else {
            this.bz = 0;
            if (!e_.originalEvent.targetTouches || e_.originalEvent.targetTouches.length < 1) {
                return;
            }
            ;
            this.bz = (e_.originalEvent.targetTouches.length);
            var d = (e_.originalEvent.targetTouches[0].pageX);
            var e = (e_.originalEvent.targetTouches[0].pageY);
            var f = BaseDOMEventProxy.cy(this.by);
            this.bv = d - f.left;
            this.bw = e - f.top;
        }
        var g = 0;
        var h = 0;
        if (Rect.l_op_Inequality(this.bf, null)) {
            g = this.bf.left;
            h = this.bf.top;
        }
        this.bt = this.bv - g;
        this.bu = this.bw - h;
        this.cx = { $type: Point_$type, x: this.bv, y: this.bw };
        this.cw = { $type: Point_$type, x: this.bt, y: this.bu };
    };
    BaseDOMEventProxy.prototype.cg = function (e_) {
        this.cq(e_);
        if (this.ab(this.cx, false, true)) {
            var deltaY_ = 0;
            var ev_ = e_;
            deltaY_ = (ev_.originalEvent ? ev_.originalEvent.deltaY : ev_.deltaY);
            var deltaX_ = 0;
            deltaX_ = (ev_.originalEvent ? ev_.originalEvent.deltaX : ev_.deltaX);
            var a = (ev_.originalEvent ? (ev_.originalEvent.deltaMode == 1) : (ev_.deltaMode == 1));
            if (a) {
                deltaY_ = deltaY_ * 40;
                deltaX_ = deltaX_ * 40;
            }
            var b = this.ag(this.cw, deltaY_);
            var c = this.ah(this.cw, deltaX_);
            if (b || c) {
                this.co(e_);
            }
        }
    };
    BaseDOMEventProxy.prototype.ce = function (e_) {
        this.cq(e_);
        this.cr(e_);
        if (this.ab(this.cx, false, true)) {
            var ev_ = e_;
            var delta_ = 0;
            if (ev_.wheelDelta) {
                delta_ = ev_.wheelDelta / 120;
            }
            ;
            if (ev_.originalEvent && ev_.originalEvent.wheelDelta) {
                delta_ = ev_.originalEvent.wheelDelta / 120;
            }
            ;
            if (ev_.detail) {
                delta_ = -ev_.detail / 3;
            }
            ;
            if (ev_.originalEvent && ev_.originalEvent.detail) {
                delta_ = -ev_.originalEvent.detail / 3;
            }
            ;
            delta_ = delta_ / 10;
            var a = this.ag(this.cw, delta_);
            if (a) {
                this.co(e_);
            }
        }
    };
    BaseDOMEventProxy.prototype.cl = function () {
        if (this.bh) {
            if (this.b0 == -1) {
                this.b0 = this.bx.setTimeout(runOn(this, this.cj), 500);
            }
            else {
                window.clearTimeout(this.b0);
                this.b0 = -1;
                this.b0 = this.bx.setTimeout(runOn(this, this.cj), 500);
            }
        }
    };
    BaseDOMEventProxy.prototype.b7 = function () {
        this.bh = true;
        if (this.b0 != -1) {
            window.clearTimeout(this.b0);
            this.b0 = -1;
        }
    };
    BaseDOMEventProxy.prototype.cj = function () {
        this.bh = false;
    };
    Object.defineProperty(BaseDOMEventProxy.prototype, "bq", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            this.bj = a;
        },
        enumerable: true,
        configurable: true
    });
    BaseDOMEventProxy.prototype.cc = function (a) {
        if (this.bj || this.bh) {
            return;
        }
        this.cr(a);
        if (this.bm) {
            this.bm = false;
            this.a3(this.cw);
        }
    };
    BaseDOMEventProxy.prototype.cd = function (a) {
        if (this.bj || this.bh) {
            return;
        }
        this.cr(a);
        this.cq(a);
        var b = new MouseEventArgs();
        b.position = this.cx;
        if (this.ab(this.cx, false, false)) {
            if (!this.bm) {
                this.bm = true;
                this.a2(this.cx);
            }
            this.a4(this.cx, true, false);
            this.at(this.cw, false);
        }
        else if (this.bm) {
            this.cc(a);
        }
    };
    BaseDOMEventProxy.prototype.cp = function (a) {
        this.by.focus(this.bp);
    };
    BaseDOMEventProxy.prototype.cb = function (a) {
        if (this.bj || this.bh) {
            return;
        }
        this.cp(a);
        this.cr(a);
        this.cq(a);
        if (this.ab(this.cx, false, false)) {
            this.bg = true;
            this.a1(this.cx);
            this.au(this.cw, false);
            this.co(a);
        }
    };
    BaseDOMEventProxy.prototype.ct = function (a) {
        if (this.bj || this.bh) {
            return;
        }
        if (this.bg) {
            this.cf(a);
        }
    };
    BaseDOMEventProxy.prototype.cf = function (a) {
        if (this.bj || this.bh) {
            return;
        }
        this.cq(a);
        if (PointUtil.equals(this.cx, null) || PointUtil.equals(this.cw, null)) {
            this.cr(a);
        }
        var b = this.ab(this.cx, false, false) || this.bg || this.bm;
        this.bg = false;
        this.a5(this.cx);
        this.as(this.cw, false);
        if (b) {
            this.co(a);
        }
    };
    BaseDOMEventProxy.prototype.b8 = function (a) {
        this.b9(a, true);
    };
    BaseDOMEventProxy.prototype.ca = function (a) {
        this.b9(a, false);
    };
    BaseDOMEventProxy.prototype.cv = function (a) {
        return BaseDOMEventProxy.cu(a);
    };
    BaseDOMEventProxy.cu = function (a) {
        var b;
        switch (a.which) {
            case 33:
                b = 10;
                break;
            case 34:
                b = 11;
                break;
            case 36:
                b = 13;
                break;
            case 37:
                b = 14;
                break;
            case 38:
                b = 15;
                break;
            case 39:
                b = 16;
                break;
            case 40:
                b = 17;
                break;
            case 9:
                b = 2;
                break;
            case 32:
                b = 9;
                break;
            case 13:
                b = 3;
                break;
            case 27:
                b = 8;
                break;
            case 16:
                b = 4;
                break;
            case 17:
                b = 5;
                break;
            case 18:
                b = 6;
                break;
            case 8:
                b = 1;
                break;
            case 35:
                b = 12;
                break;
            case 45:
                b = 18;
                break;
            case 46:
                b = 19;
                break;
            case 106:
                b = 78;
                break;
            case 107:
                b = 79;
                break;
            case 109:
                b = 80;
                break;
            case 110:
                b = 81;
                break;
            case 111:
                b = 82;
                break;
            case 220:
                b = 85;
                break;
            case 192:
                b = 86;
                break;
            case 191:
                b = 84;
                break;
            case 186:
                b = 83;
                break;
            case 189:
                b = 88;
                break;
            case 187:
                b = 87;
                break;
            default:
                if (112 <= a.which && a.which <= 123) {
                    b = (56 + a.which - 112);
                }
                else if (65 <= a.which && a.which <= 90) {
                    b = (30 + a.which - 65);
                }
                else if (48 <= a.which && a.which <= 57) {
                    b = (20 + a.which - 48);
                }
                else if (96 <= a.which && a.which <= 105) {
                    b = (68 + a.which - 96);
                }
                else {
                    b = 0;
                }
                break;
        }
        return b;
    };
    BaseDOMEventProxy.prototype.b9 = function (a, b) {
        var c = this.cv(a);
        var d = c != 0;
        this.cq(a);
        if (d) {
            var e = false;
            if (b) {
                e = this.ae(c);
            }
            else {
                e = this.af(c);
            }
            if (e) {
                this.co(a);
            }
        }
    };
    BaseDOMEventProxy.prototype.cq = function (a) {
        this.ao = a;
        this.bc = 0;
        if (a.shiftKey) {
            this.bc = this.bc | 4;
        }
        if (a.altKey) {
            this.bc = this.bc | 1;
        }
        if (a.ctrlKey) {
            this.bc = this.bc | 2;
        }
        this.ai = a.button == 2;
    };
    BaseDOMEventProxy.prototype.bd = function () {
        var a = BaseDOMEventProxy.cy(this.by);
        var b = a.left;
        var c = a.top;
        return { $type: Point_$type, x: b, y: c };
    };
    BaseDOMEventProxy.$t = markType(BaseDOMEventProxy, 'BaseDOMEventProxy', EventProxy.$);
    BaseDOMEventProxy.bn = false;
    BaseDOMEventProxy.bo = false;
    BaseDOMEventProxy.b6 = 0;
    BaseDOMEventProxy.b3 = 0;
    return BaseDOMEventProxy;
}(EventProxy));
export { BaseDOMEventProxy };
/**
 * @hidden
 */
var DOMEventProxy = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DOMEventProxy, _super);
    function DOMEventProxy(a, b, c) {
        var _this = _super.call(this) || this;
        _this.c9 = 0;
        _this.da = "";
        _this.c0 = false;
        _this.c6 = null;
        _this.c2 = new Dictionary$2(String_$type, List$1.$.specialize(Delegate_$type), 0);
        _this.dx = null;
        _this.c7 = -1;
        _this.dy = null;
        _this.c4 = 0;
        _this.c5 = 0;
        _this.c3 = 5;
        _this.cz = false;
        _this.dw = null;
        _this.br = c;
        _this.bx = b;
        _this.al = function (d) { return true; };
        _this.aa = false;
        DOMEventProxy.c8++;
        _this.c9 = DOMEventProxy.c8;
        _this.da = ".DOMProxy" + _this.c9.toString();
        _this.bc = 0;
        _this.by = a;
        BaseDOMEventProxy.bn = false;
        try {
            BaseDOMEventProxy.bn = (window.navigator.msPointerEnabled && MSGesture !== undefined);
        }
        catch (d) {
        }
        BaseDOMEventProxy.bo = false;
        try {
            BaseDOMEventProxy.bo = (window.PointerEvent || window.navigator.pointerEnabled);
        }
        catch (e) {
        }
        BaseDOMEventProxy.b6 = _this.b5();
        BaseDOMEventProxy.b3 = _this.b4();
        _this.ap(_this.by, "");
        _this.ak = function (f) { return true; };
        return _this;
    }
    DOMEventProxy.prototype.db = function (a, b, c) {
    };
    DOMEventProxy.prototype.ap = function (a, b) {
        var c = a;
        var d = this.da + b;
        if (!this.bx.supportsDOMEvents()) {
            return;
        }
        var e = new List$1(Delegate_$type, 0);
        this.c2.addItem(d, e);
        this.db(a, b, e);
        if (!BaseDOMEventProxy.bs) {
            e.add(c.listen("mousemove", runOn(this, this.cd)));
            e.add(c.listen("mouseleave", runOn(this, this.cc)));
            e.add(c.listen("mousedown", runOn(this, this.cb)));
            e.add(c.listen("mouseup", runOn(this, this.cf)));
            e.add(this.bx.globalListen("window", "mouseup", runOn(this, this.ct)));
        }
        e.add(c.listen("keydown", runOn(this, this.b8)));
        e.add(c.listen("keyup", runOn(this, this.ca)));
        var source_ = this.by.getNativeElement();
        if (!this.ac) {
            BaseDOMEventProxy.cn(source_);
        }
        if (BaseDOMEventProxy.bs) {
            var f = this.by.getNativeElement();
            if ((window.MSGesture !== undefined)) {
                var g = (new MSGesture());
                g.target = f;
                this.c6 = g;
                e.add(c.listen("MSGestureStart", runOn(this, this.de)));
                e.add(c.listen("MSGestureChange", runOn(this, this.dc)));
                e.add(c.listen("MSGestureEnd", runOn(this, this.dd)));
            }
            if (BaseDOMEventProxy.bo) {
                e.add(c.listen("pointerdown", runOn(this, this.dh)));
                e.add(c.listen("pointerup", runOn(this, this.dk)));
                e.add(c.listen("pointercancel", runOn(this, this.dg)));
                e.add(c.listen("pointermove", runOn(this, this.di)));
                e.add(c.listen("pointerout", runOn(this, this.dj)));
                e.add(c.listen("lostpointercapture", runOn(this, this.df)));
            }
            else {
                e.add(c.listen("MSPointerDown", runOn(this, this.dh)));
                e.add(c.listen("MSPointerUp", runOn(this, this.dk)));
                e.add(c.listen("MSPointerCancel", runOn(this, this.dg)));
                e.add(c.listen("MSPointerMove", runOn(this, this.di)));
                e.add(c.listen("MSPointerOut", runOn(this, this.dj)));
                e.add(c.listen("MSLostPointerCapture", runOn(this, this.df)));
            }
        }
        else {
            e.add(c.listen("gesturestart", runOn(this, this.de)));
            e.add(c.listen("gesturechange", runOn(this, this.dc)));
            e.add(c.listen("gestureend", runOn(this, this.dd)));
            e.add(c.listen("touchstart", runOn(this, this.dn)));
            e.add(c.listen("touchmove", runOn(this, this.dm)));
            e.add(c.listen("touchend", runOn(this, this.dl)));
        }
        if (this.br) {
            e.add(c.listen("wheel", runOn(this, this.cg)));
        }
        else {
            e.add(c.listen("DOMMouseScroll", runOn(this, this.ce)));
            e.add(c.listen("mousewheel", runOn(this, this.ce)));
        }
    };
    DOMEventProxy.prototype.dk = function (e_) {
        var a = this.bl(e_);
        if (a) {
            this.b2 = this.b2 - 1;
            if (this.b2 < 0) {
                this.b2 = 0;
            }
        }
        if (this.b2 < 2 && this.c0 && a) {
            this.c0 = false;
            var b = (e_.originalEvent.scale);
            this.az(this.cw, b);
        }
        else {
            if (a) {
                this.dl(e_);
            }
            else {
                this.cf(e_);
            }
        }
    };
    DOMEventProxy.prototype.df = function (e_) {
        var a = this.bl(e_);
        if (a) {
            this.b2--;
            if (this.b2 < 0) {
                this.b2 = 0;
            }
        }
        if (this.b2 < 2 && this.c0 && a) {
            this.c0 = false;
            var b = (e_.originalEvent.scale);
            this.az(this.cw, b);
        }
    };
    DOMEventProxy.prototype.dg = function (e_) {
        var a = this.bl(e_);
        if (a) {
            this.b2--;
            if (this.b2 < 0) {
                this.b2 = 0;
            }
        }
        if (this.b2 < 2 && this.c0 && a) {
            this.c0 = false;
            var b = (e_.originalEvent.scale);
            this.az(this.cw, b);
        }
    };
    DOMEventProxy.prototype.dh = function (e_) {
        var a = this.bl(e_);
        if (this.c6 != null && a) {
            this.b2++;
            this.c6.addPointer((e_.originalEvent.pointerId));
        }
        var eventSource_ = this.by.getNativeElement();
        if (BaseDOMEventProxy.bo) {
            eventSource_.setPointerCapture(e_.originalEvent.pointerId);
        }
        else {
            eventSource_.msSetPointerCapture(e_.originalEvent.pointerId);
        }
        if (this.b2 > 1 && !this.c0 && a) {
            this.c0 = true;
            this.cs(e_);
            var b = (e_.originalEvent.scale);
            this.a7(this.cw, b);
        }
        else {
            if (a) {
                this.dn(e_);
            }
            else {
                this.cb(e_);
            }
        }
    };
    DOMEventProxy.prototype.di = function (e_) {
        var a = this.bl(e_);
        if (this.c0) {
            return;
        }
        if (a) {
            this.dm(e_);
        }
        else {
            this.cd(e_);
        }
    };
    DOMEventProxy.prototype.dj = function (e_) {
        var a = this.bl(e_);
        if (this.c0) {
            return;
        }
        if (a) {
        }
        else {
            this.cc(e_);
        }
    };
    DOMEventProxy.prototype.de = function (e_) {
        this.bm = true;
        this.cq(e_);
        this.cs(e_);
        this.dq();
        if (this.ab(this.cx, true, false)) {
            this.co(e_);
            if (BaseDOMEventProxy.bs && this.b2 < 2) {
                return;
            }
            var a = (e_.originalEvent.scale);
            this.a7(this.cw, a);
        }
    };
    DOMEventProxy.prototype.dc = function (e_) {
        this.bm = true;
        this.cq(e_);
        this.cs(e_);
        if (this.ab(this.cx, true, false)) {
            this.co(e_);
            if (BaseDOMEventProxy.bs && this.b2 < 2) {
                return;
            }
            var a = (e_.originalEvent.scale);
            this.a6(this.cw, a);
        }
    };
    DOMEventProxy.prototype.dd = function (e_) {
        this.co(e_);
        var a = (e_.originalEvent.scale);
        this.bm = false;
        this.cq(e_);
        this.cs(e_);
        if (!BaseDOMEventProxy.bs || this.c0) {
            this.az(this.cw, a);
        }
    };
    DOMEventProxy.prototype.dn = function (e_) {
        this.bm = true;
        this.cq(e_);
        this.cs(e_);
        this.dx = this.cw;
        if (this.ab(this.cx, true, false)) {
            if (!this.aa) {
                this.co(e_);
            }
            else {
                this.bq = true;
            }
            this.a4(this.cx, false, true);
            this.a1(this.cx);
            this.au(this.cw, true);
            this.dt();
        }
    };
    DOMEventProxy.prototype.dt = function () {
        if (this.c7 == -1) {
            this.c4 = this.cx.x;
            this.c5 = this.cx.y;
            this.c7 = this.bx.setTimeout(runOn(this, this.dr), 1500);
        }
    };
    DOMEventProxy.prototype.dq = function () {
        if (Math.abs(this.c4 - this.cx.x) > this.c3 || Math.abs(this.c5 - this.cx.y) > this.c3) {
            this.du();
        }
    };
    DOMEventProxy.prototype.du = function () {
        if (this.c7 != -1) {
            window.clearTimeout(this.c7);
            this.c7 = -1;
        }
    };
    DOMEventProxy.prototype.dr = function () {
        this.c7 = -1;
        if (this.bq) {
            this.bq = false;
            this.b7();
        }
        this.a0(this.cw);
    };
    DOMEventProxy.prototype.dm = function (a) {
        this.bm = true;
        this.cq(a);
        this.cs(a);
        if (this.bq) {
            if (this.ab(this.cx, true, false) && this.c1()) {
                this.bq = false;
                this.b7();
            }
        }
        this.dq();
        this.dv();
        if (this.ab(this.cx, true, false) && this.b2 == 1 && !this.bq) {
            this.co(a);
            if (!this.cz) {
                this.cz = true;
                this.dw = this.cw;
                this.ay(this.dw);
            }
            else {
                this.a4(this.cx, true, true);
                this.at(this.cw, true);
                this.ax(this.cw);
            }
        }
    };
    DOMEventProxy.prototype.c1 = function () {
        var a = { $type: Point_$type, x: this.dx.x - this.cw.x, y: this.dx.y - this.cw.y };
        if (Math.abs(a.x) < 2 && Math.abs(a.y) < 2) {
            return false;
        }
        if (Math.abs(a.x) > Math.abs(a.y)) {
            a.y = 0;
        }
        if (Math.abs(a.y) > Math.abs(a.x)) {
            a.x = 0;
        }
        return this.al(a);
    };
    DOMEventProxy.prototype.dl = function (a) {
        this.bm = false;
        this.cq(a);
        this.cs(a);
        this.du();
        if (this.bq) {
            this.bq = false;
            this.b7();
        }
        this.co(a);
        this.a4(this.cx, false, true);
        this.a5(this.cx);
        if (this.b2 == 0) {
            this.ds(this.cx);
            this.cl();
        }
        if (this.cz && this.b2 == 0) {
            this.cz = false;
            this.dw = null;
            this.aw(this.cw);
            this.cl();
        }
        this.as(this.cw, true);
    };
    DOMEventProxy.prototype.ds = function (a) {
        if (Rect.l_op_Equality(this.dy, null)) {
            this.dy = new Rect(0, a.x - 50, a.y - 50, 100, 100);
            this.bx.setTimeout(runOn(this, this.dv), 500);
        }
        else {
            if (a.x >= this.dy.x && a.x <= this.dy.right && a.y >= this.dy.y && a.y <= this.dy.bottom) {
                this.dv();
                this.av(a);
            }
        }
    };
    DOMEventProxy.prototype.dv = function () {
        this.dy = null;
    };
    DOMEventProxy.prototype.dp = function (a) {
        if (this.c2.containsKey(a)) {
            var b = this.c2.item(a);
            this.c2.removeItem(a);
            for (var c = 0; c < b.count; c++) {
                b._inner[c]();
            }
            b.clear();
        }
    };
    DOMEventProxy.prototype.bb = function (a, b) {
        var c = a;
        var d = this.da + b;
        this.dp(d);
    };
    DOMEventProxy.prototype.aq = function () {
        if (this.by == null) {
            return;
        }
        this.dp(this.da);
        this.by = null;
    };
    DOMEventProxy.$t = markType(DOMEventProxy, 'DOMEventProxy', BaseDOMEventProxy.$);
    DOMEventProxy.c8 = 0;
    return DOMEventProxy;
}(BaseDOMEventProxy));
export { DOMEventProxy };
//# sourceMappingURL=BaseDOMEventProxy_combined.js.map
